<template>
    <portal-layout :defaultTitle="false">

        <template #title>
            <div class="flex items-center justify-between w-full">
                <h1 class="mb-5 text-4xl font-bold text-primary-700 lg:mb-0">Your Patient Record</h1>
                <!-- <div v-if="hasRecord" class="relative cursor-pointer" @click.prevent="router.push('/notifications')">
                    <BellIcon class="w-7 h-7" />
                    <div class="absolute top-0 right-0 w-4 h-4 bg-red-700 border-4 border-white rounded-full has-notif"></div>
                </div> -->
            </div>
        </template>
        
        <template #fields>
            <vue-barcode v-if="hasRecord"
                :value="patientData.hospital_no" 
                :options="{ displayValue: true }" 
                class="mr-6"
            />
        </template>
        
        <MedicalRecordForm v-if="!hasRecord"/>

        <div class="" v-if="hasRecord">
            <div class="p-5 mb-6 bg-white rounded-lg">
                <p class="mb-6 text-xl font-bold text-primary-500">Patient Details</p>
                <div class="grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0">
                    <div class="col-span-full lg:col-span-6 space-y-2.5 lg:mb-14">
                        <div class="flex justify-between">
                            <p>First Name</p>
                            <p class="font-bold">{{ patientData.first_name ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Middle Name</p>
                            <p class="font-bold">{{ patientData.middle_name ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Last Name</p>
                            <p class="font-bold">{{ patientData.last_name ?? '-' }}</p>
                        </div>
                    </div>

                    <div class="col-span-full lg:col-span-6 space-y-2.5 lg:mb-14">
                        <div class="flex justify-between">
                            <p>Date of Birth</p>
                            <p class="font-bold">{{ patientData.birthdate ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Sex</p>
                            <p class="font-bold">{{ patientData.sex ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Nationality</p>
                            <p class="font-bold">{{ patientData.nationality ?? '-' }}</p>
                        </div>
                    </div>

                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>Civil Status</p>
                            <p class="font-bold">{{ patientData.civil_status ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Email Address</p>
                            <p class="font-bold">{{ patientData.email_address ?? '-' }}</p>
                        </div>
                    </div>
                    
                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>Telephone Number</p>
                            <p class="font-bold">{{ patientData.telephone_number ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Cellphone Number</p>
                            <p class="font-bold">+63 {{ patientData.cellphone_number ?? '-' }}</p>
                        </div>
                    </div>
                </div>

                <div class="my-8 border-b border-black/[.04]"></div>

                <p class="mb-6 font-bold text-primary-500">Local Address</p>
                <div class="grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0">
                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>Province</p>
                            <p class="font-bold">{{ patientData.province ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Barangay</p>
                            <p class="font-bold">{{ patientData.barangay ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>No./Bldg.</p>
                            <p class="font-bold">{{ patientData.building_number ?? '-' }}</p>
                        </div>
                    </div>

                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>City/Municipality</p>
                            <p class="font-bold">{{ patientData.city ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Street</p>
                            <p class="font-bold">{{ patientData.street ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>ZIP Code</p>
                            <p class="font-bold">{{ patientData.zip_code ?? '-' }}</p>
                        </div>
                    </div>
                </div>

                <div class="my-8 border-b border-black/[.04]"></div>

                <p class="mb-6 font-bold text-primary-500">Permanent Address</p>
                <div class="grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0">
                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>Province</p>
                            <p class="font-bold">{{ patientData.permanent_province ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Barangay</p>
                            <p class="font-bold">{{ patientData.permanent_barangay ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>No./Bldg.</p>
                            <p class="font-bold">{{ patientData.permanent_building_number ?? '-' }}</p>
                        </div>
                    </div>

                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>City/Municipality</p>
                            <p class="font-bold">{{ patientData.permanent_city ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Street</p>
                            <p class="font-bold">{{ patientData.permanent_street ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>ZIP Code</p>
                            <p class="font-bold">{{ patientData.permanent_zip_code ?? '-' }}</p>
                        </div>
                    </div>
                </div>

                <div class="my-8 border-b border-black/[.04]"></div>

                <div class="grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0">
                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>PhilHealth No</p>
                            <p class="font-bold">{{ patientData.philhealth_number ?? '-' }}</p>
                        </div>
                    </div>

                    <div class="col-span-full lg:col-span-6 space-y-2.5 lg:mb-2.5">
                        <div class="flex justify-between">
                            <p>HMO</p>
                            <p class="font-bold">{{ patientData.hmo_name ?? '-' }}</p>
                        </div>
                    </div>

                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>Senior Citizen ID</p>
                            <p 
                                v-if="patientData.senior_citizen_id_base_64"
                                class="font-bold transition cursor-pointer text-primary-500 hover:text-primary-700"
                                @click="viewID(patientData.senior_citizen_id_base_64)"
                            >
                                View ID
                            </p>
                            <p
                                v-else
                                class="font-bold transition cursor-pointer text-primary-500 hover:text-primary-700"
                                @click="showSrIdUpload = true"
                            >
                                Upload ID
                            </p>                                             
                        </div>
                    </div>

                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>PWD ID</p>
                            <p 
                                v-if="patientData.pwd_id_base_64"
                                class="font-bold transition cursor-pointer text-primary-500 hover:text-primary-700"
                                @click="viewID(patientData.pwd_id_base_64)"
                            >
                                View ID
                            </p>
                            <p
                                v-else
                                class="font-bold transition cursor-pointer text-primary-500 hover:text-primary-700"
                                @click="showPwdIdUpload = true"
                            >
                                Upload ID
                            </p>
                           
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-5 mb-6 bg-white rounded-lg">
                <p class="mb-6 text-xl font-bold text-primary-500">Occupation</p>
                <div class="grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0">
                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>Title</p>
                            <p class="font-bold">{{ patientData.job_title ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Contact Number</p>
                            <p class="font-bold">+63 {{ patientData.company_contact_no ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Company Email Address</p>
                            <p class="font-bold">{{ patientData.company_email ?? '-' }}</p>
                        </div>
                    </div>

                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>Company Name</p>
                            <p class="font-bold">{{ patientData.company_name ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Address</p>
                            <p class="font-bold text-right max-w-[70%]">{{ patientData.company_address ?? '-' }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-5 mb-2 bg-white rounded-lg">
                <p class="mb-6 text-xl font-bold text-primary-500">Person to notify in case of emergency</p>
                <div class="grid grid-cols-1 lg:grid-cols-12 gap-x-11 space-y-2.5 lg:space-y-0">
                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>Name</p>
                            <p class="font-bold">{{ patientData.contact_person_name ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Contact Number</p>
                            <p class="font-bold">+63 {{ patientData.contact_person_number ?? '-' }}</p>
                        </div>
                    </div>

                    <div class="col-span-full lg:col-span-6 space-y-2.5">
                        <div class="flex justify-between">
                            <p>Relationship</p>
                            <p class="font-bold">{{ patientData.contact_person_relationship ?? '-' }}</p>
                        </div>
                        <div class="flex justify-between">
                            <p>Email Address</p>
                            <p class="font-bold">{{ patientData.contact_person_email ?? '-' }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <p class="text-sm text-darkgray-400">If you want to make any changes to any of the information shown above, you may contact us via our trunkline <a href="tel:(02) 736-85239" class="font-bold">(02) 736-85239</a>.</p>
        </div>

        <PageLoader v-if="loader" />

        <ErrorModal
            width="w-[548px]"
            title="Error"
            action-text="Close"
            cancel-text="Go back"
            :show="showError"
            @close="showError = false"
            @confirm="showError = false"
        >
            <template #content>
                {{ errorMsg }}
            </template>
        </ErrorModal>

    </portal-layout>

    <UploadIDModal 
        title="Upload Senior Citizen ID"
        :dialog="showSrIdUpload"
        :patientId="patientData.patient_id"
        type="sr_id"
        import-route="medical-record/upload-patient-id"
        @onClose="showSrIdUpload = false"
    />   

    <UploadIDModal 
        title="Upload PWD ID"
        :dialog="showPwdIdUpload"
        :patientId="patientData.patient_id"
        type="pwd_id"
        import-route="medical-record/upload-patient-id"
        @onClose="showPwdIdUpload = false"
    />      
</template>

<script setup lang="ts">
import PortalLayout from '@/layouts/PortalLayout.vue';
import MedicalRecordForm from './MedicalRecordForm.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import VueBarcode from '@chenfengyuan/vue-barcode';
import UploadIDModal from "@/components/modal/UploadIDModal.vue";
import { useRouter } from 'vue-router';
import { BellIcon } from '@heroicons/vue/24/outline';

import patient from "@/classes/UserData";
import { ref, computed } from 'vue';

const patientData = computed(() => patient.getCurrentUser())

const router = useRouter();

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const showSrIdUpload = ref<boolean>(false)
const showPwdIdUpload = ref<boolean>(false)

const hasRecord = computed(() => {
    console.log(patientData.value);
    return (patientData.value.cellphone_number !== null && patientData.value.cellphone_number !== "TBA")
        && (patientData.value.province !== null && patientData.value.province !== "TBA")
        && (patientData.value.city !== null && patientData.value.city !== "TBA")
        && (patientData.value.barangay !== null && patientData.value.barangay !== "TBA")
        && (patientData.value.street !== null && patientData.value.street !== "TBA")
        && (patientData.value.company_name !== null && patientData.value.company_name !== "TBA")
        && (patientData.value.company_address !== null && patientData.value.company_address !== "TBA")
        && (patientData.value.contact_person_name !== null && patientData.value.contact_person_name !== "TBA")
        && (patientData.value.contact_person_number !== null && patientData.value.contact_person_number !== "TBA")
        && (patientData.value.contact_person_relationship !== null && patientData.value.contact_person_relationship !== "TBA");
});

const viewID = (base64: string): void => {
    const pattern = /data:image\/[^;]+;base64,+/;
    base64 = base64.replace(pattern, "");

    const mime = getMimeType(base64);
    const decodedString = atob(base64);
    const uint8Array = Uint8Array.from([...decodedString].map(char => char.charCodeAt(0)));
    const blob = new Blob([uint8Array], { type: mime });
    const testResultFile = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = testResultFile;
    link.target = '_blank';
    link.click();
}

const getMimeType = (base64:string):string|null => {
    const signatures = {
        JVBERi0: "application/pdf",
        R0lGODdh: "image/gif",
        R0lGODlh: "image/gif",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpeg"
    };

    for (const index in signatures) {
        if (base64.indexOf(index) === 0) {
            return signatures[index];
        }
    }
    
    return null;
}

</script>